"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerPoses = void 0;
//0: STANDING, 1: FALL_FLYING, 2: SLEEPING, 3: SWIMMING, 4: SPIN_ATTACK, 5: SNEAKING, 6: LONG_JUMPING, 7: DYING
var PlayerPoses;
(function (PlayerPoses) {
    PlayerPoses[PlayerPoses["STANDING"] = 0] = "STANDING";
    PlayerPoses[PlayerPoses["FALL_FLYING"] = 1] = "FALL_FLYING";
    PlayerPoses[PlayerPoses["SLEEPING"] = 2] = "SLEEPING";
    PlayerPoses[PlayerPoses["SWIMMING"] = 3] = "SWIMMING";
    PlayerPoses[PlayerPoses["SPIN_ATTACK"] = 4] = "SPIN_ATTACK";
    PlayerPoses[PlayerPoses["SNEAKING"] = 5] = "SNEAKING";
    PlayerPoses[PlayerPoses["LONG_JUMPING"] = 6] = "LONG_JUMPING";
    PlayerPoses[PlayerPoses["DYING"] = 7] = "DYING";
})(PlayerPoses = exports.PlayerPoses || (exports.PlayerPoses = {}));
